export default __webpack_public_path__ + "static/media/logo_mini.b154cd7b.png";